export default __webpack_public_path__ + "static/media/cpp.c9bdc587.jpg";